import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CounterOfferDto,
  CounterOfferRequestDto,
  NegotiationHistoryDto
} from '../models/shift-request.model';

export interface INegotiationService {
  getNegotiationHistory(requestId: string): Observable<NegotiationHistoryDto>;
  submitCounterOffer(
    requestId: string,
    body: CounterOfferRequestDto
  ): Observable<CounterOfferDto>;
  /** Accept the latest counter-offer from the other party. */
  acceptLatestOffer(requestId: string): Observable<void>;
}

export const NEGOTIATION_SERVICE = new InjectionToken<INegotiationService>(
  'NEGOTIATION_SERVICE'
);
